document.addEventListener('DOMContentLoaded', () => {
  const pickerBlockSelected = document.querySelector('.byteex-product-picker-block-selected');
  const pickerBlockPopupWrapper = document.querySelector('.byteex-product-picker-block-popup-wrapper');
  const pageContentWrapper = document.getElementById('byteex-product-content-wrapper');
  const pickerBlockPopupClose = document.querySelector('.byteex-product-picker-block-popup-close');
  const progressNumber = document.querySelector('.byteex-product-picker-block-popup-progress-number');
  const progressType = document.querySelector('.byteex-product-picker-block-popup-progress-type');
  const addToCartButtonWrapper = document.querySelector('.byteex-button-wrapper');
  const chooseButtonWrapper = document.querySelector('.byteex-choose-button');
  const allProductsOnPicker = document.querySelectorAll('.byteex-product-picker-block-popup-products-item');
  const piecesCount = parseInt(pickerBlockSelected.dataset.piecesCount);

  // Open Picker Popup from choose button
  chooseButtonWrapper.addEventListener('click', () => {
    pageContentWrapper.style.position = 'static';
    pickerBlockPopupWrapper.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  // Open Picker Popup
  pickerBlockSelected.addEventListener('click', () => {
    pageContentWrapper.style.position = 'static';
    pickerBlockPopupWrapper.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  // Close Picker Popup
  pickerBlockPopupClose.addEventListener('click', () => {
    pageContentWrapper.style.position = 'sticky';
    pickerBlockPopupWrapper.classList.remove('active');
    document.body.style.overflow = 'auto';
  });

  // Size picker on each product on popup
  const popupProductsItemSizePickerSelected = document.querySelectorAll('.popup-products-item-size-picker-selected');
  popupProductsItemSizePickerSelected.forEach((item, index, array) => {
    const parentElement = item.parentElement;
    const pickerOptions = parentElement.querySelector('.popup-products-item-size-picker-options');
    const pickerOption = parentElement.querySelectorAll('.popup-products-item-size-picker-option');
    const selectedValueElement = item.querySelector('.popup-products-item-size-picker-selected-value');

    function chooseOptionHandler() {
      const value = this.dataset.value;
      selectedValueElement.textContent = value;
      selectedValueElement.dataset.value = value;
      pickerOptions.classList.remove('active');
      parentElement.querySelector('svg').style.transform = 'rotate(0deg)';
      pickerOption.forEach(option => option.removeEventListener('click', chooseOptionHandler));

      checkIfVariantIsAvailable(parentElement);
    }

    item.addEventListener('click', (e) => {
      e.stopPropagation();

      // close other open pickers
      array.forEach(otherItem => {
        const _parent = otherItem.parentElement;
        const _pickerOptions = _parent.querySelector('.popup-products-item-size-picker-options');
        if (_pickerOptions.classList.contains('active') && _parent !== parentElement) {
          _pickerOptions.classList.remove('active');
          _parent.querySelector('svg').style.transform = 'rotate(0deg)';
          const _pickerOption = _parent.querySelectorAll('.popup-products-item-size-picker-option');
          _pickerOption.forEach(option => option.removeEventListener('click', chooseOptionHandler));
        }
      });

      // open/close current picker
      if (pickerOptions.classList.contains('active')) {
        pickerOptions.classList.remove('active');
        parentElement.querySelector('svg').style.transform = 'rotate(0deg)';
        pickerOption.forEach(option => option.removeEventListener('click', chooseOptionHandler));
      } else {
        pickerOptions.classList.add('active');
        parentElement.querySelector('svg').style.transform = 'rotate(180deg)';
        pickerOption.forEach(option => {
          option.addEventListener('click', chooseOptionHandler);
          if (option.dataset.value === selectedValueElement.dataset.value) {
            option.classList.add('active');
          } else {
            option.classList.remove('active');
          }
        });
      }
    });

    // close when clicking outside parentElement
    document.addEventListener('click', (e) => {
      if (!parentElement.contains(e.target)) {
        pickerOptions.classList.remove('active');
        parentElement.querySelector('svg').style.transform = 'rotate(0deg)';
        pickerOption.forEach(option => option.removeEventListener('click', chooseOptionHandler));
      }
    });
  });

  // Color picker on each product on popup
  const colorSwatchButtons = document.querySelectorAll('.popup-products-item-color-swatch-button');
  colorSwatchButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      const currentButton = event.currentTarget;
      const parentElement = currentButton.parentElement;
      const curentColorSwatchButtons = parentElement.querySelectorAll(
        '.popup-products-item-color-swatch-button',
      );

      curentColorSwatchButtons.forEach((button) => {
        button.classList.remove('active');
        button.style.backgroundColor = button.dataset.color;
        button.dataset.selected = 'false';
      });

      currentButton.classList.add('active');
      currentButton.style.backgroundColor = 'transparent';
      currentButton.dataset.selected = 'true';

      checkIfVariantIsAvailable(parentElement);
    });
  }); 

  // Check if variant is available function
  function checkIfVariantIsAvailable(element) {
    const product_item = element.closest('.byteex-product-picker-block-popup-products-item');
    const productVariants = JSON.parse(product_item.dataset.productVariants);

    let selectedColor = '';
    const colorOptions = product_item.querySelectorAll(
      '.popup-products-item-color-swatch-button',
    );
    colorOptions.forEach((option) => {
      const isSelected = option.dataset.selected === 'true';
      if (isSelected) {
        selectedColor = option.dataset.value;
      }
    });

    let selectedSize = '';
    const selectedSizeOption = product_item.querySelector(
      '.popup-products-item-size-picker-selected-value',
    );
    if (selectedSizeOption) {
      selectedSize = selectedSizeOption.dataset.value;
    }

    const currentColorSwatchButtons = product_item.querySelectorAll('.popup-products-item-color-swatch-button');
    currentColorSwatchButtons.forEach((button) => {
      const currentValue = button.dataset.value;
      productVariants.forEach((variant) => {
        if (variant.size === selectedSize && variant.color === currentValue) {
          if (!variant.available) {
            button.classList.add('disabled');
          } else {
            button.classList.remove('disabled');
          }
        }
      });
    });

    const currentSizeSelectorButtons = product_item.querySelectorAll('.popup-products-item-size-picker-option');
    currentSizeSelectorButtons.forEach((button) => {
      const currentValue = button.dataset.value;
      productVariants.forEach((variant) => {
        if (variant.size === currentValue && variant.color === selectedColor) {
          if (!variant.available) {
            button.classList.add('disabled');
          } else {
            button.classList.remove('disabled');
          }
        }
      });
    });

    const currentSelectedSizeValue = product_item.querySelector('.popup-products-item-size-picker-selected-value');
    if (currentSelectedSizeValue) {
      const selectedSizeValue = currentSelectedSizeValue.dataset.value;
      
      productVariants.forEach((variant) => {
        if (variant.size === selectedSizeValue && variant.color === selectedColor) {
          if (!variant.available) {
            currentSelectedSizeValue.classList.add('disabled');
          } else {
            currentSelectedSizeValue.classList.remove('disabled');
          }
        }
      });
    }

    const currentAddButton = product_item.querySelector('.byteex-product-picker-block-popup-products-add-button');
    const atcText = currentAddButton.dataset.atc;
    const soldOutText = currentAddButton.dataset.soldOut;

    let isVariantAvailable;
    if (productVariants.length > 1) {
      productVariants.forEach((variant) => {
        if (variant.size === selectedSize && variant.color === selectedColor) {
          if (variant.available) {
            isVariantAvailable = true;
          }
        }
      });
    } else {
      isVariantAvailable = true;
    }

    if (isVariantAvailable) {
      currentAddButton.textContent = atcText;
      currentAddButton.removeAttribute('disabled');
    } else {
      currentAddButton.textContent = soldOutText;
      currentAddButton.setAttribute('disabled', 'disabled');
    }
  }

  // Check if variant is available on all products on popup
  allProductsOnPicker.forEach((product) => {
    checkIfVariantIsAvailable(product);
  });

  const productsCategories = document.querySelectorAll('.byteex-product-picker-block-popup-products');
  const productsCategoriesData = [];
  productsCategories.forEach((category) => {
    productsCategoriesData.push(category.dataset.category);
  });

  // filter
  const filterButtons = document.querySelectorAll('.byteex-product-picker-block-popup-filter-button');

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const filterValue = button.dataset.filter;

      filterButtons.forEach((button) => {
        button.classList.remove('active');
        const color = button.querySelector('.byteex-product-picker-block-popup-filter-color');
        if (color) {
          color.style.backgroundColor = color.dataset.color;
        }
      });

      button.classList.add('active');
      const color = button.querySelector('.byteex-product-picker-block-popup-filter-color');
      if (color) {
        color.style.backgroundColor = 'transparent';
      }

      if (filterValue === 'silver') {
        allProductsOnPicker.forEach((product) => {
          const productWithSilver = product.querySelector('button[data-value="Silver"]');

          if (productWithSilver) {
            product.style.display = 'flex';
          } else {
            product.style.display = 'none';
          }
        });
      } else {
        allProductsOnPicker.forEach((product) => {
          product.style.display = 'flex';
        });
      }
    });
  });

  // get selected products count
  const selectedProductsCountElement = document.querySelector('.byteex-product-picker-block-popup-selected-products-count-value');
  function getSelectedProductsCount() {
    const selectedProducts = document.querySelectorAll('.byteex-product-picker-block-selected-item-image-wrapper.active');
    return selectedProducts.length;
  }

  // get next step
  const selectedProducts = document.querySelectorAll('.byteex-product-picker-block-selected-item-image-wrapper');
  function getNextStep() {
    for (let i = 0; i < selectedProducts.length; i++) {
      const product = selectedProducts[i];
  
      if (!product.classList.contains('active')) {
        return [i + 1, productsCategoriesData[i]];
      }
    }
  
    return null;
  }

  // go to previous step
  const prevButton = document.querySelector('.byteex-product-picker-block-popup-progress-prev');
  prevButton.addEventListener('click', () => {
    const active = document.querySelector('.byteex-product-picker-block-popup-products.active');
    const prev = active?.previousElementSibling;    
  
    if (prev) {
      active.classList.remove('active');
      prev.classList.add('active');
      const category = prev.dataset.category;

      productsCategories.forEach((item, index) => {
        const activeCategory = item.dataset.category;
        if (activeCategory === category) {
          progressNumber.textContent = index + 1;
          progressType.textContent = activeCategory;
        }
      });
    }    
  });

  // go to next step  
  const nextButton = document.querySelector('.byteex-product-picker-block-popup-progress-next');
  nextButton.addEventListener('click', () => {
    const active = document.querySelector('.byteex-product-picker-block-popup-products.active');
    const next = active?.nextElementSibling;
  
    if (next) {
      active.classList.remove('active');
      next.classList.add('active');
      const category = next.dataset.category;

      productsCategories.forEach((item, index) => {
        const activeCategory = item.dataset.category;
        if (activeCategory === category) {
          progressNumber.textContent = index + 1;
          progressType.textContent = activeCategory;
        }
      });      
    }    
  });

  // Product lens and images popup
  const productLenses = document.querySelectorAll('.byteex-product-picker-block-popup-products-item-lens');
  const productImagesPopup = document.querySelector('.byteex-product-picker-block-popup-images-popup');
  const productImagesPopupTitle = document.querySelector('.byteex-product-picker-block-popup-images-popup-title');
  const productImagesPopupImages = document.querySelector('.byteex-product-picker-block-popup-images-popup-images');

  productLenses.forEach((lens) => {
    lens.addEventListener('click', () => {
      productImagesPopup.classList.add('active');
  
      const title = lens.dataset.title;
      const images = lens.dataset.images.split(',');
  
      productImagesPopupTitle.textContent = title;
  
      productImagesPopupImages.innerHTML = '';
      productImagesPopupImages.scrollTop = 0;
  
      // skeleton
      images.forEach((image) => {
        if (!image) return;

        const skeleton = document.createElement('div');
        skeleton.classList.add('byteex-image-skeleton');
        productImagesPopupImages.appendChild(skeleton);
      });
  
      // load images
      images.forEach((image, index) => {
        if (!image) return;
  
        const img = new Image();
  
        img.onload = () => {
          img.classList.add('byteex-product-picker-block-popup-images-popup-image');
  
          const skeleton = productImagesPopupImages.children[index];
          if (skeleton) {
            skeleton.replaceWith(img);
          }
        };
  
        img.src = image;
      });
    });
  });

  const productImagesPopupClose = document.querySelector('.byteex-product-picker-block-popup-images-popup-close');
  productImagesPopupClose.addEventListener('click', () => {
    productImagesPopup.classList.remove('active');
  });

  // Add button on each product on popup
  const addButtons = document.querySelectorAll('.byteex-product-picker-block-popup-products-add-button');
  addButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const parentElement = button.parentElement;
      const productVariants = JSON.parse(parentElement.dataset.productVariants);
      const category = button.dataset.category;
      const image = button.dataset.image;

      let selectedColor = '';
      const colorOptions = parentElement.querySelectorAll(
        '.popup-products-item-color-swatch-button',
      );
      colorOptions.forEach((option) => {
        const isSelected = option.dataset.selected === 'true';
        if (isSelected) {
          selectedColor = option.dataset.value;
        }
      });

      let selectedSize = '';
      const selectedSizeOption = parentElement.querySelector(
        '.popup-products-item-size-picker-selected-value',
      );
      if (selectedSizeOption) {
        selectedSize = selectedSizeOption.dataset.value;
      }

      let selectedVariant;

      if (productVariants.length === 1) {
        selectedVariant = productVariants[0].id;
      } else {
        productVariants.forEach((variant) => {
          if (
            variant.size === selectedSize &&
            variant.color === selectedColor
          ) {
            selectedVariant = variant.id;
          }
        });
      }

      const selectedProduct = document.querySelector(
        `.byteex-product-picker-block-selected-item[data-category="${category}"]`,
      );
      const selectedProductImageWrapper = selectedProduct.querySelector(
        '.byteex-product-picker-block-selected-item-image-wrapper',
      );
      selectedProductImageWrapper.classList.add('active');

      const selectedProductImage = selectedProduct.querySelector('img');
      selectedProductImage.src = image;

      const selectedProductPicker = document.querySelector(
        `.byteex-product-picker-block-popup-selected-item-image-wrapper[data-category="${category}"]`,
      );
      selectedProductPicker.classList.add('active');

      const selectedProductPickerImage = selectedProductPicker.querySelector('img');
      selectedProductPickerImage.src = image;

      const selectedProductsCount = getSelectedProductsCount();
      selectedProductsCountElement.textContent = selectedProductsCount;


      const pickerProgressBarStep = document.querySelector(
        `.byteex-product-picker-block-popup-progress-bar-step[data-category="${category}"]`,
      );
      pickerProgressBarStep.classList.add('active');

      // set variant
      productsCategoriesData.forEach((currentCategory, index) => {
        if (currentCategory === category) {
          const input = document.getElementById(`byteex-form-property-id${index + 1}`);
          input.value = selectedVariant;
        }
      });

      if (selectedProductsCount === piecesCount) {
        pickerBlockPopupClose.click();

        addToCartButtonWrapper.classList.add('submit');
        addToCartButtonWrapper.setAttribute('type', 'submit');
        addToCartButtonWrapper.setAttribute('data-add-to-cart', '');
      } else {
        const nextStep = getNextStep();
        if (nextStep) {
          const [index, category] = nextStep;
          productsCategories.forEach((category) => {
            category.classList.remove('active');
          });
          const nextProducts = document.querySelector(
            `.byteex-product-picker-block-popup-products[data-category="${category}"]`,
          );
          nextProducts.classList.add('active');

          progressNumber.textContent = index;
          progressType.textContent = category;
        }      
      }      
    });
  });

  // Remove button on each product on popup
  const removeButtons = document.querySelectorAll('.byteex-product-picker-block-popup-selected-products-remove');
  removeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const category = button.dataset.category;

      const selectedProduct = document.querySelector(
        `.byteex-product-picker-block-selected-item[data-category="${category}"]`,
      );
      const selectedProductImageWrapper = selectedProduct.querySelector(
        '.byteex-product-picker-block-selected-item-image-wrapper',
      );
      selectedProductImageWrapper.classList.remove('active');

      const selectedProductImage = selectedProduct.querySelector('img');
      selectedProductImage.removeAttribute('src');


      const selectedProductPicker = document.querySelector(
        `.byteex-product-picker-block-popup-selected-item-image-wrapper[data-category="${category}"]`,
      );
      selectedProductPicker.classList.remove('active');

      const selectedProductPickerImage = selectedProductPicker.querySelector('img');
      selectedProductPickerImage.removeAttribute('src');

      const selectedProductsCount = getSelectedProductsCount();
      selectedProductsCountElement.textContent = selectedProductsCount;


      const pickerProgressBarStep = document.querySelector(
        `.byteex-product-picker-block-popup-progress-bar-step[data-category="${category}"]`,
      );
      pickerProgressBarStep.classList.remove('active');

      addToCartButtonWrapper.classList.remove('submit');
      addToCartButtonWrapper.setAttribute('type', 'button');
      addToCartButtonWrapper.removeAttribute('data-add-to-cart');


      const nextStep = getNextStep();
      if (nextStep) {
        const [index, category] = nextStep;
        productsCategories.forEach((category) => {
          category.classList.remove('active');
        });
        const nextProducts = document.querySelector(
          `.byteex-product-picker-block-popup-products[data-category="${category}"]`,
        );
        nextProducts.classList.add('active');

        progressNumber.textContent = index;
        progressType.textContent = category;
      }  
    });
  });

  // Upsell Block
  const byteexUpsellButton = document.querySelector('.byteex-upsell-block-button');
  const byteexUpsellInput = document.getElementById('byteex-upsell-product-id');

  byteexUpsellButton.addEventListener('click', () => {
    if (byteexUpsellInput.disabled) {
      byteexUpsellInput.disabled = false;
      byteexUpsellButton.textContent = byteexUpsellButton.dataset.addedText;
    } else {
      byteexUpsellInput.disabled = true;
      byteexUpsellButton.textContent = byteexUpsellButton.dataset.addText;
    }
  });
});
